// extracted by mini-css-extract-plugin
module.exports = {"labelContainer":"TagsDropdown_labelContainer__1KT4q","label":"TagsDropdown_label__3saX7 EditableInput_label__9rOng","altText":"TagsDropdown_altText__OdHuJ"};